module.exports = "/images/blue_house.jpg?5553fdbb6d00c29b75e8a80d390fe2a3";